/**
 * WidgetRenderer — discriminated-union dispatch from a WidgetSpec +
 * execution result to the concrete Widget component.
 */

import { WidgetBar } from './widgets/WidgetBar'
import { WidgetComparison } from './widgets/WidgetComparison'
import { WidgetKPI } from './widgets/WidgetKPI'
import { WidgetLine } from './widgets/WidgetLine'
import { WidgetTable } from './widgets/WidgetTable'
import type { WidgetSpec, WidgetExecutionResult } from './types'

interface WidgetRendererProps {
  widget: WidgetSpec
  result?: WidgetExecutionResult
}

export function WidgetRenderer({ widget, result }: WidgetRendererProps) {
  switch (widget.type) {
    case 'kpi':
      return <WidgetKPI widget={widget} data={result?.data} error={result?.error} />
    case 'bar':
      return <WidgetBar widget={widget} data={result?.data} error={result?.error} />
    case 'line':
      return <WidgetLine widget={widget} data={result?.data} error={result?.error} />
    case 'table':
      return <WidgetTable widget={widget} data={result?.data} error={result?.error} />
    case 'comparison':
      return <WidgetComparison widget={widget} data={result?.data} error={result?.error} />
    default: {
      const _exhaustive: never = widget
      void _exhaustive
      return null
    }
  }
}
